// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g63-D","content":"styles_content__1CU6V","row":"styles_row__1hlDn","footer":"styles_footer__1bL6F","phraseLength":"styles_phraseLength__2gH4A"};